import { Outlet } from "react-router-dom";
const MainLayout = () => {
  return (
      <Outlet />
  );
};

export default MainLayout;